import PropTypes from 'prop-types';

const ToolbarPropTypes = PropTypes.shape({
  fullName: PropTypes.string,
  companyName: PropTypes.string,
  showReporting: PropTypes.bool,
  showMarketing: PropTypes.bool,
  showCompanySetup: PropTypes.bool,
  activeTab: PropTypes.string,
  quickbooksBadgeData: PropTypes.shape({
    qboErrorCount: PropTypes.number,
    qbdErrorCount: PropTypes.number,
    qboEnabled: PropTypes.bool,
    qbdEnabled: PropTypes.bool,
  }),
  canAddJob: PropTypes.bool,
  isConnectedToOnCallAir: PropTypes.bool,
  canUseVirtualEstimates: PropTypes.bool,
  orgLogoUrl: PropTypes.string,
  thumbLogoUrl: PropTypes.string,
  variant: PropTypes.string,
  orgUuid: PropTypes.string,
  isSuperPro: PropTypes.bool,
  didCompleteSetupOnboarding: PropTypes.bool,
  showAdvancedReporting: PropTypes.bool,
  showAddProposal: PropTypes.bool,
  canUsePriceBook: PropTypes.bool,
  canChatWithCustomers: PropTypes.bool,
  canUsePipeline: PropTypes.bool,
  productLeadGrowthPath: PropTypes.bool,
});

export default ToolbarPropTypes;
